define(function (require) {
	const data_item_tpl = require('../templates/t_itv_action_data_item.hbs');
	const utils = require('civicsUtils/general_utilities');
	return Marionette.ItemView.extend({
		template: data_item_tpl,
		ui: {
			'button':'.action-button'
		},
		events: {
			'click @ui.button':'buttonClicked'
		},
		initialize: function (options) {
			if (options && options.callback) {
				this.callback = options.callback;
			}
		},
		buttonClicked:function(e) {
			if (e) {
				e.stopPropagation();
				e.preventDefault();
			}
			if (this.callback) {
				this.callback();
			}
		},
		templateHelpers: function () {

			var isLink = (this.model.has('isLink') && this.model.get('isLink'));
			return {
				elementId: this.model.cid,
				linkClicked: (isLink) ? "onclick=\"if(!event.ctrlKey) window.location.assign('" + this.model.get('url') + "');" +
										" else window.open('" + this.model.get('url') + "');\"" +
										" oncontextmenu=\"this.href='" + this.model.get('url') + "'\"" +
										" onmousemove=\"this.href='javascript:void(0)'\"" : ''
			}
		}
	});
});
